import PropTypes from 'prop-types';

import Heading from 'shopper/components/Heading';
import Text from 'shopper/components/Text';
import Tooltip from 'shopper/components/Tooltip';

import GamificationProgressBar from 'components/GamificationProgressBar';

import { getCurrentXpValue } from 'lib/number';

const GamificationExperience = ({
  userLevel,
  userXp,
  userXpEntryLevel,
  userXpNextLevel,
  userXpTitle,
}) => (
  <div className="mt-4 flex w-full flex-col items-end md:mt-0 md:w-unset">
    <div className="flex w-full items-center justify-between">
      <Heading
        className="text-neutral-high-200 dark:text-neutral-high-200"
        size="size6"
      >
        {userXpTitle}
      </Heading>
      <Text className="text-neutral-high-200 dark:text-neutral-high-200">{`Nível ${userLevel}`}</Text>
    </div>
    <Tooltip.Root className="mt-2 w-full md:w-[224px]">
      <Tooltip.Trigger>
        <GamificationProgressBar
          max="100"
          value={getCurrentXpValue(userXp, userXpNextLevel)}
        />
      </Tooltip.Trigger>
      <Tooltip.Box bold>{userXp} pontos</Tooltip.Box>
    </Tooltip.Root>
    <Text
      className="mt-2 text-neutral-high-200 dark:text-neutral-high-200"
      bold
    >
      {`${userXpEntryLevel} / ${userXpNextLevel}`}
    </Text>
  </div>
);

GamificationExperience.propTypes = {
  userLevel: PropTypes.number.isRequired,
  userXp: PropTypes.number.isRequired,
  userXpEntryLevel: PropTypes.number.isRequired,
  userXpNextLevel: PropTypes.number.isRequired,
  userXpTitle: PropTypes.string.isRequired,
};

export default GamificationExperience;
